module.exports = __webpack_public_path__ + "img/pc.4c7f6a34.svg";